import { render, staticRenderFns } from "./scopecompanyproduct.vue?vue&type=template&id=6eb8caca&"
import script from "./scopecompanyproduct.vue?vue&type=script&lang=js&"
export * from "./scopecompanyproduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports